/** @jsxImportSource @emotion/react */

import { memo } from "react";
import { useHistory } from "react-router-dom";

import { AppBar, Toolbar, IconButton, Container } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import logoUrl from "../../../assets/images/logo-moment.svg";
import { RoutesProps, Routes } from "../../../routes";

import { appBar, header, logo, container } from "./styles";

export interface Props {
  routes: RoutesProps[];
  from?: string;
}

const NoticeLayout = ({ routes, from }: Props): JSX.Element => {
  const { push } = useHistory();
  return (
    <>
      <AppBar css={appBar}>
        <Toolbar>
          <div css={header}>
            <img css={logo} src={logoUrl} alt="KKStream Live" />
          </div>
          <IconButton
            size="small"
            aria-label="close"
            edge="end"
            color="primary"
            onClick={() => push(from || "/live/events")}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Container css={container}>
        <Routes routes={routes} />
      </Container>
    </>
  );
};
export default memo(NoticeLayout);
